import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span [class]="'badge badge--' + variant + ' badge--' + size">
      <ng-content></ng-content>
    </span>
  `,
  styles: [`
    .badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      padding: 2px 8px;
      font-weight: 400;
      white-space: nowrap;
    }
    
    .badge--primary {
      background-color: #87CCF8;
      color: #323232;
    }
    
    .badge--secondary {
      background-color: #E0E0E0;
      color: #323232;
    }
    
    .badge--sm {
      font-size: 9.95px;
    }
    
    .badge--md {
      font-size: 11px;
    }
  `]
})
export class BadgeComponent {
  @Input() variant: 'primary' | 'secondary' = 'primary';
  @Input() size: 'sm' | 'md' = 'sm';
}